import { combineReducers } from "redux";
import entitiesReducer from "./entities";
import uiReducer from "./ui";

const reducers = combineReducers({ entities: entitiesReducer, ui: uiReducer });

export default reducers;

export type State = ReturnType<typeof reducers>;
